import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { HBox } from '../../../../components/Box';
import { selectInvoice } from '../../../Invoices/selectors';
import { selectAddressTypes } from '../../../Address/selectors';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';

const Footer = styled(HBox)`
  height: 80px;
  align-items: center;
  .page-number-label {
    white-space: nowrap;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class SaleAgreementFooterComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  renderPageNumber() {
    return <span className={'page-number-label'}>{this.props.page}</span>;
  }

  renderIdwFooter() {
    return (
      <Footer style={{ marginTop: '30px' }}>
        <HBox right vCenter>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/idw/vindatlogo.jpg" width="90" />
          </div>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/idw/element.jpg" width="80" />
          </div>
        </HBox>
        {this.renderPageNumber()}
      </Footer>
    );
  }

  renderHarryNijboer() {
    return (
      <Footer style={{ marginTop: '30px' }}>
        <HBox right vCenter>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/idw/vindatlogo.jpg" width="90" />
          </div>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/harrynijboer/element.jpg" width="80" />
          </div>
        </HBox>
        {this.renderPageNumber()}
      </Footer>
    );
  }

  renderHooikammer() {
    return (
      <Footer>
        <HBox right vCenter>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/idw/vindatlogo.jpg" width="90" />
          </div>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/hooikammer/element.jpg" width="70" />
          </div>
        </HBox>
        {this.renderPageNumber()}
      </Footer>
    );
  }

  renderAutohuissalland() {
    return (
      <Footer>
        <HBox right vCenter>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/idw/vindatlogo.jpg" width="90" />
          </div>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/autohuissalland/logo.jpg" width="70" />
          </div>
        </HBox>
        {this.renderPageNumber()}
      </Footer>
    );
  }

  renderWientjesFooter() {
    return (
      <Footer>
        <HBox style={{ width: '70%', textAlign: 'center' }}>
          Op alle rechtsverhoudingen met ons zijn algemene leveringsvoorwaarden van toepassing, welke op www.autowientjes.nl
          staan gepubliceerd
        </HBox>
        <HBox spaceAround vCenter style={{ width: '30%' }}>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/autowientjes/bosch.jpg" width="70" />
          </div>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/autowientjes/bovag.jpg" width="70" />
          </div>
          <div id="indewal-logo" className="logo">
            <img src="/public/invoice/autowientjes/duurzaa.jpg" width="70" />
          </div>
        </HBox>
        {this.renderPageNumber()}
      </Footer>
    );
  }

  render() {
    if (env.clientId == AppClientId.AUTOWIENTJES) {
      return this.renderWientjesFooter();
    }
    if (env.clientId == AppClientId.HARRY_NIJBOER) {
      return this.renderHarryNijboer();
    }

    if (env.clientId == AppClientId.HOOIKAMMER) {
      return this.renderHooikammer();
    }
    if (env.clientId == AppClientId.AUTOHUISSALLAND) {
      return this.renderAutohuissalland();
    }
    return this.renderIdwFooter();
  }
}

SaleAgreementFooterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.outgoingInvoiceId),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SaleAgreementFooter = compose(withConnect, withRouter)(SaleAgreementFooterComp);
